import React, { useState, useEffect } from 'react'; 
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { BaseURL, uniqueToken } from '../../api/DataApis';
import axios from 'axios';
import image from "../../assets/images/dummy_pic.jpeg";

function View(props) {
  document.title = "Station | View";
  let navigate = useNavigate();
  let location = useLocation();
  const params = useParams();
  const StationID = params.wid;

  let StationViewData = location.state?.StationViewData;

  const [StationData, setStationData] = useState({});
  const [loading, setLoading] = useState(true); // Loader state

  const fetchData = async () => {
    const apiEndpoint = `${BaseURL}/station/${StationID}`;
    try {
      let res = await axios.get(apiEndpoint, {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`,
        }
      });

      if (res && res.data) {
        setStationData(res.data.data); // Set the fetched station data
      } else {
        console.error("No station data found");
      }
    } catch (error) {
      console.error("Error fetching station data:", error);
    } finally {
      setLoading(false); // Stop loader when data is fetched
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  console.log("StationDataaaaaaaaaaaa", StationData);

  return (
    <div className="container-fluid">
      <div className="row justify-content-center">
        <div className="col-sm-12">
          <div className="card mt-4 p-4">
            {loading ? (
              <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <>
                <h2 className="text-center">Station Information</h2>

                {/* Centered Image */}
                <div className="d-flex justify-content-center mt-3">
                  <img
                    className="profile-image mb-4"
                    src={StationData?.station_images[0]?.imageURL || image}
                    alt="Station"
                    style={{
                      width: '150px',
                      height: '150px',
                      objectFit: 'cover',
                      borderRadius: '50%',
                      border: '3px solid #ddd'
                    }}
                  />
                </div>

                {/* Station Details */}
                <div className="row">
                  <div className="col-sm-6 mb-3">
                    <p><strong>Station Name:</strong> {StationData?.station_name}</p>
                  </div>
                  <div className="col-sm-6 mb-3">
                    <p><strong>Station Address:</strong> {StationData?.address}</p>
                  </div>
                  <div className="col-sm-6 mb-3">
                    <p><strong>Longitude:</strong> {StationData?.longitude}</p>
                  </div>
                  <div className="col-sm-6 mb-3">
                    <p><strong>Latitude:</strong> {StationData?.latitude}</p>
                  </div>
                  <div className="col-sm-6 mb-3">
                    <p><strong>Created At:</strong> {StationData?.createdAt}</p>
                  </div>
                  <div className="col-sm-6 mb-3">
                    <p><strong>Updated At:</strong> {StationData?.updatedAt}</p>
                  </div>
                  <div className="col-sm-6 mb-3">
                    <p><strong>Status:</strong> {StationData?.status}</p>
                  </div>
                  <div className="col-sm-6 mb-3">
                    <p><strong>Vendor Name:</strong> {StationData?.service_provider?.[0]?.service_provider_id[0]?.name}</p>
                  </div>
                  <div className="col-sm-6 mb-3">
                    <p><strong>Vendor Mobile :</strong> {StationData?.service_provider?.[0]?.service_provider_id[0]?.mobile}</p>
                  </div>
                  <div className="col-sm-6 mb-3">
                    <p><strong>Percentage:</strong> {StationData?.service_provider?.[0]?.percentage}</p>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default View;
